import { gql } from '@apollo/client'

export const createOrderPackingSlipDocumentLinkQuery = gql`
  mutation createOrderPackingSlipDocumentLink($input: CreateOrderPackingSlipDocumentLinkArgs!) {
    createOrderPackingSlipDocumentLink(input: $input) {
      token
      expiresAt
    }
  }
`
